import React from 'react';

import PropertyComps from './index';

export default function LeasePropertyComps(props) {
  return <PropertyComps {...props} type="lease" />;
}
